<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>生态充值审核</h1>
        <p>对公转账在这里确认或驳回。确认后积分进入对方积分池。微信和支付宝到账后自动入池，不用在这里点确认。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">待审核</div><div class="v">{{ pendingCount }} 笔</div></div>
      <div class="ch-metric"><div class="k">当前筛选</div><div class="v">{{ total }} 笔</div></div>
      <div class="ch-metric"><div class="k">本页</div><div class="v">{{ list.length }} 笔</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <select v-model="status" @change="go(1)">
          <option value="PENDING">待审核</option>
          <option value="PAYING">待支付</option>
          <option value="CONFIRMED">已到账</option>
          <option value="REJECTED">已驳回</option>
          <option value="ALL">全部</option>
        </select>
        <input v-model="keyword" placeholder="伙伴名称" @keyup.enter="go(1)" />
        <button class="ch-btn" type="button" @click="go(1)">查询</button>
      </div>
      <table class="ch-table">
        <thead>
          <tr><th>时间</th><th>伙伴</th><th>原价</th><th>积分</th><th>方式</th><th>状态</th><th>凭证</th><th>操作</th></tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.createdAt }}</td>
            <td>{{ row.partnerName || row.partnerId }}</td>
            <td>¥ {{ row.yuanAmount }}</td>
            <td>{{ row.points }}</td>
            <td>{{ channelText(row.payChannel) }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusText(row.status) }}</span></td>
            <td>
              <a v-if="row.proofUrl" :href="fileUrl(row.proofUrl)" target="_blank" rel="noopener">查看凭证</a>
              <span v-else>—</span>
            </td>
            <td class="ops">
              <template v-if="row.status === 'PENDING'">
                <button class="ch-link" type="button" @click="decide(row, 'confirm')">确认到账</button>
                <button class="ch-link" type="button" @click="decide(row, 'reject')">驳回</button>
              </template>
              <span v-else-if="row.status === 'PAYING'" class="ch-note">到账后自动入账</span>
              <span v-else>—</span>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="8" class="ch-empty">没有符合条件的充值单</td></tr>
        </tbody>
      </table>
      <div class="ch-filters" style="margin-top:12px">
        <button class="ch-btn" type="button" :disabled="page <= 1" @click="go(page - 1)">上一页</button>
        <span class="ch-note">第 {{ page }} / {{ pages }} 页</span>
        <button class="ch-btn" type="button" :disabled="page >= pages" @click="go(page + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getEcoRechargeReviews, confirmEcoRecharge } from '@/api/admin'
import { resolveFileUrl } from '@/utils/fileUrl'

export default {
  name: 'HqEcoRecharges',
  data() {
    return { list: [], total: 0, pendingCount: 0, page: 1, pageSize: 20, status: 'PENDING', keyword: '' }
  },
  computed: {
    pages() { return Math.max(1, Math.ceil(this.total / this.pageSize)) }
  },
  created() { this.load() },
  methods: {
    fileUrl: resolveFileUrl,
    channelText(channel) {
      if (channel === 'wechat') return '微信'
      if (channel === 'alipay') return '支付宝'
      if (channel === 'bank') return '对公转账'
      return '未选方式'
    },
    statusText(status) {
      if (status === 'PENDING') return '待审核'
      if (status === 'PAYING') return '待支付'
      if (status === 'CONFIRMED') return '已到账'
      if (status === 'REJECTED') return '已驳回'
      return status || '—'
    },
    tagOf(status) {
      if (status === 'CONFIRMED') return 'ok'
      if (status === 'REJECTED') return 'bad'
      if (status === 'PAYING') return 'muted'
      return 'warn'
    },
    async load() {
      const result = await getEcoRechargeReviews({
        status: this.status,
        keyword: this.keyword.trim(),
        page: this.page,
        pageSize: this.pageSize
      })
      this.list = result.list || []
      this.total = result.total || 0
      this.pendingCount = result.pendingCount || 0
      this.page = result.page || this.page
    },
    go(page) {
      this.page = page
      this.load()
    },
    async decide(row, action) {
      const verb = action === 'confirm' ? '确认到账' : '驳回'
      try {
        await this.$confirm('对「' + (row.partnerName || '该伙伴') + '」¥' + row.yuanAmount + ' ' + verb + '？', verb, { type: 'warning' })
      } catch (e) {
        return
      }
      await confirmEcoRecharge(row.id, { action })
      this.$message.success(action === 'confirm' ? '已入积分池' : '已驳回')
      this.load()
    }
  }
}
</script>

<style scoped>
.ops { white-space: nowrap; }
.ops .ch-link + .ch-link { margin-left: 20px; }
</style>
